import { render, staticRenderFns } from "./EmailHistoryTab.vue?vue&type=template&id=654b91b4&scoped=true&"
import script from "./EmailHistoryTab.vue?vue&type=script&lang=js&"
export * from "./EmailHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654b91b4",
  null
  
)

export default component.exports